export default "__VITE_ASSET__e0100cea__"